function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 25.314,
  r: 24,
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 25.314,
  r: 23.7934,
  stroke: "#1A1A1A",
  strokeWidth: 0.413178
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 76.9997,
  cy: 25.3139,
  r: 23.027,
  fill: "#0D0D0D"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 76.9997,
  cy: 25.3139,
  r: 22.8204,
  stroke: "#2F2504",
  strokeWidth: 0.413178
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 76.9985,
  cy: 25.314,
  r: 19.4595,
  fill: "url(#paint1_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M96.3961 24.985C96.3961 14.4538 87.7116 5.9165 76.9988 5.9165C66.286 5.9165 57.6016 14.4538 57.6016 24.985",
  stroke: "url(#paint2_linear)",
  strokeWidth: 0.413178
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  width: 2.64889,
  height: 11.7382,
  rx: 1.32445,
  transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 78.6484 11.314)",
  fill: "url(#paint3_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 77,
  y1: 1.31396,
  x2: 77,
  y2: 49.314,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4D566"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4F4F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 76.9985,
  y1: 5.85449,
  x2: 76.9985,
  y2: 44.7734,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5F4A00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A1A1A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 76.9988,
  y1: 5.9165,
  x2: 76.9988,
  y2: 24.985,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4D566"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#474747",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 1.32445,
  y1: 0,
  x2: 1.32445,
  y2: 11.7382,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F1C733"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2CE4D",
  stopOpacity: 0
})));

function SvgStableIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46.0547,
    height: 46.054,
    viewBox: "53 1.31396 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStableIcon);
export default __webpack_public_path__ + "static/media/stable-icon.193c4f4694427562241403a4dbba80ee.svg";
export { ForwardRef as ReactComponent };